import { useState, useEffect } from 'react';
import { systemSettingsApi } from '../services/api';

/**
 * Converts week start day string to date-fns format (0-6)
 * Sunday = 0, Monday = 1, ..., Saturday = 6
 */
const dayStringToNumber = (dayString: string): 0 | 1 | 2 | 3 | 4 | 5 | 6 => {
  const dayMap: Record<string, 0 | 1 | 2 | 3 | 4 | 5 | 6> = {
    'sunday': 0,
    'monday': 1,
    'tuesday': 2,
    'wednesday': 3,
    'thursday': 4,
    'friday': 5,
    'saturday': 6
  };
  return dayMap[dayString.toLowerCase()] ?? 1; // Default to Monday
};

/**
 * Hook to get the universal week start day setting from Attendance settings
 * Returns the week start day as a number (0-6) for use with date-fns startOfWeek/endOfWeek
 */
export const useWeekStartDay = (): 0 | 1 | 2 | 3 | 4 | 5 | 6 => {
  const [weekStartDay, setWeekStartDay] = useState<0 | 1 | 2 | 3 | 4 | 5 | 6>(1); // Default to Monday

  useEffect(() => {
    const fetchWeekStartDay = async () => {
      try {
        const setting = await systemSettingsApi.getByKey('week_start_day');
        if (setting?.value) {
          setWeekStartDay(dayStringToNumber(setting.value));
        }
      } catch (error) {
        console.error('Error fetching week start day setting:', error);
        // Keep default value on error
      }
    };

    fetchWeekStartDay();
  }, []);

  return weekStartDay;
};
